import { render, staticRenderFns } from "./taxLoyalitiesList.vue?vue&type=template&id=203195c0&scoped=true&"
import script from "./taxLoyalitiesList.vue?vue&type=script&lang=js&"
export * from "./taxLoyalitiesList.vue?vue&type=script&lang=js&"
import style0 from "./taxLoyalitiesList.vue?vue&type=style&index=0&id=203195c0&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203195c0",
  null
  
)

export default component.exports